<template>
	<div>
		<div v-if="hasContent" class="content">
			<slot></slot>
		</div>

		<b-notification v-if="errorMessage" type="is-danger">
			<span v-html="errorMessage" />
		</b-notification>

		<draggable
			:list="myValue"
			:group="{ draggable: '.listing-brochure' }"
			@end="end"
		>
			<form-file
				v-for="(_name, index) in myFields"
				:key="index"
				:name="_name"
				class="listing-brochure"
				:on-delete="() => deleteFile(index)"
			/>

			<progress
				v-if="progress"
				class="progress is-primary"
				:value="progress"
				max="100"
			>
				{{ progress }}%
			</progress>

			<dropzone
				:id="name"
				:options="options"
				:class="{ 'is-active': myFields.length }"
				@vdropzone-error="uploadError"
				@vdropzone-error-multiple="uploadError"
				@vdropzone-success="success"
				@vdropzone-total-upload-progress="upload"
				@vdropzone-queue-complete="complete"
			/>

			<p v-if="showError" class="help is-danger">{{ error }}</p>
		</draggable>
		<div class="my-preview"></div>
	</div>
</template>

<script>
// TODO: this is *almost* the same as FormImageGallary. Make ONE....
import Dropzone from "vue2-dropzone";
import draggable from "vuedraggable";
import fieldArrayMixin from "@lab/utils/fieldArrayMixin";
import FormFile from "./FormFile";

export default {
	components: { Dropzone, FormFile, draggable },
	mixins: [fieldArrayMixin],
	props: {
		label: {
			type: String,
			default: () => null
		}
	},
	data() {
		return {
			progress: null,
			errorMessage: null
		};
	},
	computed: {
		myValue: {
			get() {
				return this.myFields;
			},
			set() {
				// Updating is handled via 'end'
			}
		},
		options() {
			return {
				url: process.env.VUE_APP_SERVICES + "/media/pdf",
				headers: {
					Authorization:
						"BEARER " + window.localStorage.getItem("token")
				},
				dictDefaultMessage:
					"<i class='fa fa-cloud-upload'></i> Click or drag files to upload",
				dictFileTooBig:
					"<strong>It looks like you've selected a very large file to upload ({{filesize}}MB)</strong><br/>Please check that the file size is less than {{maxFilesize}}MB",
				previewsContainer: ".my-preview",
				acceptedFiles: "application/pdf",
				maxFilesize: 12,
				maxFiles: 10
			};
		},
		hasContent() {
			return !!this.$slots.default;
		}
	},
	methods: {
		uploadError(file, message) {
			this.errorMessage = message;
		},
		upload(totaluploadprogress) {
			this.progress = totaluploadprogress;
		},
		complete() {
			this.progress = null;
		},
		success(file, response) {
			response.status = "uploaded";
			if (response["url"]) {
				this.fieldPush(response);
			}
		},
		deleteFile(index) {
			this.confirm(
				`Delete file?`,
				`Are you sure you would like to remove this file?`,
				"is-warning",
				"Confirm deletion",
				() => this.fieldRemove(index)
			);
		},
		end(change) {
			this.fieldMove(change.oldIndex, change.newIndex);
		}
	}
};
</script>

<style lang="scss" scoped>
.button {
	margin-top: 10px;
}

.dropzone {
	min-height: 80px;
	font-family: "proxima-nova", sans-serif;

	.dz-message {
		transition: all 0.2s ease-out;
		display: block !important;
	}
	.dz-preview {
		display: none !important;
	}

	&.is-active {
		.dz-message {
			margin: 1em 0;
		}
	}
}

.my-preview {
	display: none;
}
</style>
